var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilter = function SvgIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    fillOpacity: 0.88,
    d: "M7.333 13.334a.65.65 0 0 1-.475-.192.65.65 0 0 1-.191-.475v-4L2.8 3.734a.64.64 0 0 1-.075-.7q.176-.367.608-.367h9.334q.434 0 .608.367a.64.64 0 0 1-.075.7L9.333 8.667v4a.65.65 0 0 1-.191.475.65.65 0 0 1-.475.192zM8 8.2 11.3 4H4.7z"
  })));
};
export default SvgIconFilter;